import { t } from '@lingui/macro';
import { z } from 'zod';

export const SignInSchema = () =>
  z.object({
    email: z
      .string({ required_error: t`L'email est obligatoire.` })
      .trim()
      .email(t`L'email n'est pas valide`)
      .min(1, t`L'email est obligatoire.`),
    password: z
      .string({
        required_error: t`Le mot de passe est obligatoire.`,
        invalid_type_error: t`Le mot de passe doit être valide.`,
      })
      .trim()
      .min(1, t`Le mot de passe est obligatoire.`),
    // .min(6, `Le mot de passe doit contenir au moins 6 caractères.`),
  });

export type SignInSchemaT = z.infer<ReturnType<typeof SignInSchema>>;
